// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__zUrRy","header":"style_header__MeUs3","content":"style_content__fMGCP","footer":"style_footer___xHxZ"};